import { render, staticRenderFns } from "./home.vue?vue&type=template&id=bd58f0a2&scoped=true&"
import script from "./home.ts?vue&type=script&lang=ts&"
export * from "./home.ts?vue&type=script&lang=ts&"
import style0 from "./home.styl?vue&type=style&index=0&id=bd58f0a2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd58f0a2",
  null
  
)

export default component.exports